import { render, staticRenderFns } from "./config-glance.vue?vue&type=template&id=329f1382&scoped=true&"
import script from "./config-glance.vue?vue&type=script&lang=js&"
export * from "./config-glance.vue?vue&type=script&lang=js&"
import style0 from "./config-glance.vue?vue&type=style&index=0&id=329f1382&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329f1382",
  null
  
)

export default component.exports